import { render, staticRenderFns } from "./BSMButton.vue?vue&type=template&id=56443f4f&scoped=true"
import script from "./BSMButton.vue?vue&type=script&lang=js"
export * from "./BSMButton.vue?vue&type=script&lang=js"
import style0 from "./BSMButton.vue?vue&type=style&index=0&id=56443f4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56443f4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
